import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ImageIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 6.75C4 5.23122 5.23122 4 6.75 4H17.25C18.7688 4 20 5.23122 20 6.75V17.25C20 18.7688 18.7688 20 17.25 20H6.75C5.23122 20 4 18.7688 4 17.25V16.0064C3.99996 16.0018 3.99996 15.9972 4 15.9926V6.75ZM5.5 16.2595V17.25C5.5 17.9404 6.05964 18.5 6.75 18.5H17.25C17.9404 18.5 18.5 17.9404 18.5 17.25V12.8091C18.4758 12.7875 18.4528 12.764 18.4311 12.7387L16.0167 9.92821C16.0167 9.9282 16.0167 9.9282 16.0167 9.92819C15.5046 9.33218 14.5766 9.351 14.089 9.96608L13.5013 9.50017L14.0901 9.96468C14.0894 9.96563 14.089 9.96615 14.0888 9.96636L14.0846 9.97194L14.0846 9.97192L14.066 9.9959C13.8953 10.2166 12.8193 11.6077 11.8852 12.8013L13.5689 14.7613C13.8388 15.0755 13.8029 15.549 13.4887 15.8189C13.1745 16.0888 12.701 16.0529 12.4311 15.7387L10.3563 13.3236C10.349 13.3154 10.3418 13.3071 10.3349 13.2986L10.0167 12.9282L10.0167 12.9282C9.50351 12.3308 8.5725 12.3511 8.08582 12.9702L8.08581 12.9702L5.5 16.2595ZM10.8701 11.6643C9.70746 10.6519 7.89256 10.7889 6.90656 12.0432L5.5 13.8324V6.75C5.5 6.05964 6.05964 5.5 6.75 5.5H17.25C17.9404 5.5 18.5 6.05964 18.5 6.75V10.517L17.1545 8.95075L17.1545 8.95073C16.0279 7.63944 13.9864 7.68096 12.9136 9.03426L12.9125 9.03566C12.9078 9.04161 12.9024 9.04854 12.8964 9.0564L12.8792 9.07852C12.7171 9.2882 11.7577 10.5284 10.8701 11.6643Z"
        fill="currentColor"
      />
    </svg>
  );
};
